"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagLocalizedReferenceSchema = void 0;
exports.TagLocalizedReferenceSchema = {
    "$id": "https://www.redbull.com/schemas/reference/localized/content/tags.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "TagLocalizedReference",
    "description": "A tag is the foundation of our taxonomy. It helps to intertwine our content.",
    "type": "object",
    "required": [
        "type",
        "id"
    ],
    "properties": {
        "type": {
            "enum": [
                "rrn:content:tags"
            ],
            "type": "string"
        },
        "id": {
            "type": "string",
            "pattern": "^rrn:content:[0-9a-z\\-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}:[a-z]{2}-[A-Z]{2,3}$"
        }
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGFncy5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9yZWZlcmVuY2UvbG9jYWxpemVkL2NvbnRlbnQvdGFncy5zY2hlbWEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSwyQkFBMkIsR0FBRztJQUN6QyxLQUFLLEVBQUUsOEVBQThFO0lBQ3JGLFNBQVMsRUFBRSw4Q0FBOEM7SUFDekQsT0FBTyxFQUFFLHVCQUF1QjtJQUNoQyxhQUFhLEVBQUUsOEVBQThFO0lBQzdGLE1BQU0sRUFBRSxRQUFRO0lBQ2hCLFVBQVUsRUFBRTtRQUNWLE1BQU07UUFDTixJQUFJO0tBQ0w7SUFDRCxZQUFZLEVBQUU7UUFDWixNQUFNLEVBQUU7WUFDTixNQUFNLEVBQUU7Z0JBQ04sa0JBQWtCO2FBQ25CO1lBQ0QsTUFBTSxFQUFFLFFBQVE7U0FDakI7UUFDRCxJQUFJLEVBQUU7WUFDSixNQUFNLEVBQUUsUUFBUTtZQUNoQixTQUFTLEVBQUUsaUdBQWlHO1NBQzdHO0tBQ0Y7Q0FDRixDQUFBIn0=